import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody30';
import Footer from '../component/Footer'
import { Helmet } from 'react-helmet';

const CaseStudy30 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'>REIT Market research for </h2><h4>a KSA-based real estate fund manager</h4>";

  return (
    <>
        <Helmet>
        <title>REIT Market research for a KSA-based real estate fund manager</title>
        <meta property="og:title" content="REIT Market research for a KSA-based real estate fund manager" />
        <meta property='og:description' content='REIT Market research for a KSA-based real estate fund manager'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy30" headings={headings} />  
        <Casestudybody />
        <Footer setBlank={setBlank} />
    </>
  )
}

export default CaseStudy30
